import * as React from "react"

import { cn } from "@/utils/cn"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string
}

/** Общие классы полей ввода — используются Input, Textarea, SelectTrigger и комбобоксами */
export const fieldClasses =
  "flex h-9 w-full min-w-0 rounded-md border border-input bg-field px-3 py-1.5 text-sm text-foreground shadow-xs transition-[color,box-shadow,border-color] duration-150 placeholder:text-muted-foreground/80 hover:border-muted-foreground/40 focus-visible:border-ring focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/20 disabled:cursor-not-allowed disabled:bg-muted/60 disabled:opacity-60 aria-[invalid=true]:border-destructive aria-[invalid=true]:ring-destructive/20"

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    const input = (
      <input
        type={type}
        className={cn(
          fieldClasses,
          "file:mr-3 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          error && "border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20",
          className
        )}
        aria-invalid={error ? true : props["aria-invalid"]}
        ref={ref}
        {...props}
      />
    )

    if (error === undefined) {
      return input
    }

    // Сообщение об ошибке — под полем; обёртка нужна только в этом случае
    return (
      <div className="w-full">
        {input}
        {error && (
          <p className="mt-1.5 text-xs font-medium text-destructive">{error}</p>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
